import * as React from "react";
import * as $ from "jquery";
import { IScenarioState } from "./Scenario";
import { Game } from "./Game";

interface IScenarionSummaryState {
    errors?:string[];
}
export interface IScenarioSummaryProps {
    state: IScenarioState;
    onContinue: () => void;
}
export class ScenarioSummaryComponent extends React.Component<IScenarioSummaryProps, IScenarionSummaryState> {
    constructor(props: IScenarioSummaryProps) {
        super(props);
        this.state = {};
    }
    postAnswersAndContinue() {
        if (this.props.state.resolution) {
            const questions = this.props.state.resolution.questions;
            if (questions && questions.length) {
                const errors: string[] = [];
                const answers: number[] = [];
                for (let i = 0; i < questions.length; i++) {
                    const jQuery = $("input.question[name='question_" + i + "']:checked");
                    if (jQuery.length) {
                        const answer = parseInt("" + jQuery.val());
                        answers.push(answer);
                    } else {
                        errors.push("You must answer question " + (i + 1));
                    }
                }
                if (errors.length) {
                    this.setState({ errors: errors });
                    return;
                }
                this.props.state.resolution.completeQuestions(this.props.state, answers);
            }
        }
        this.props.onContinue();
    }
    render() {
        const scenario = Game.getScenario(this.props.state);
        const items = this.props.state.scenarioLog.map((t, i) => (<li key={i}>{t}</li>));
        let questions: JSX.Element[] = null;
        if (this.props.state.resolution && this.props.state.resolution.questions) {
            questions = this.props.state.resolution.questions.map((q, i) => {

                const choices = q.choices.map((c, j) => {
                    return (<div className="radio"><label><input type="radio" className="question" name={"question_"+i} value={j.toString()}/>{c}</label></div>);
                });

                return (<li>
                    <div className="form-group">
                        <p>
                            {q.question}
                        </p>
                        {choices}
                        </div>
                </li>);
            });
        }
        let errors: JSX.Element[] = null;
        if (this.state.errors && this.state.errors.length) {
            errors = this.state.errors.map((e, i) => {
                return (<li key={i} className="validation-error">{e}</li>)});
        }
        return (
            <div className="container">
                <div className="col col-md-12 p-t-30">
                    <div className="summary scenario-summary">
                        <div className="content-box">

                            <h1>Scenario summary:</h1>
                            <h2> {scenario.name}</h2>

                            <ul className="scenario-log">
                                {items}
                            </ul>
                            <ul>{errors}</ul>
                            <ul>{questions}</ul>
                            <div className="clearfix">
                                <div className="pull-right">
                                    <button onClick={() => this.postAnswersAndContinue()}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
